import React from "react";
import { Crown, ArrowUpRight } from "lucide-react";

const INVESTORS = [
  {
    name: "Warren Buffett",
    role: "Chairman · Berkshire Hathaway",
    return: "+19.8% / yr",
    style: "Value · Long-term",
    avatarBg: "candy-gradient-blue",
    initials: "WB",
  },
  {
    name: "Cathie Wood",
    role: "CEO & CIO · Ark Invest",
    return: "+32.1% peak",
    style: "Innovation · Disruptive",
    avatarBg: "candy-gradient-purple",
    initials: "CW",
  },
  {
    name: "Nancy Pelosi",
    role: "52nd Speaker, US HoR",
    return: "+65% / 2024",
    style: "Tech-heavy · Options",
    avatarBg: "candy-gradient-pink",
    initials: "NP",
  },
];

const MasterInvestors = () => {
  return (
    <section
      id="masters"
      data-testid="masters-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <div className="max-w-2xl">
            <span className="inline-flex items-center gap-2 rounded-full bg-[#FEF3C7] px-4 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-[#92400E]">
              <Crown size={14} /> Master Investors
            </span>
            <h2 className="font-display mt-5 text-4xl sm:text-5xl font-black tracking-tighter text-slate-900 leading-[1.05]">
              Mirror the moves of{" "}
              <span className="brand-gradient-text">legends.</span>
            </h2>
            <p className="mt-4 text-lg text-slate-600 leading-relaxed">
              Access real-time portfolio updates from Warren, Cathie, Nancy and
              more. See how pros allocate across sectors — then test their
              strategies in your sim.
            </p>
          </div>
          <div className="hidden md:flex items-center gap-3 text-sm font-semibold text-slate-500">
            Updated daily
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-emerald-400 opacity-60" />
              <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500" />
            </span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {INVESTORS.map((inv, i) => (
            <div
              key={inv.name}
              data-testid={`investor-card-${inv.name.toLowerCase().replace(/\s+/g, "-")}`}
              className="group relative rounded-3xl bg-white border border-slate-100 p-7 hover:-translate-y-1 transition-all duration-300 shadow-[0_4px_20px_rgb(0,0,0,0.03)] hover:shadow-[0_20px_50px_rgb(0,0,0,0.08)]"
            >
              <div className="absolute top-7 right-7 opacity-0 group-hover:opacity-100 transition-opacity">
                <div className="w-9 h-9 rounded-full brand-gradient flex items-center justify-center">
                  <ArrowUpRight size={16} className="text-white" />
                </div>
              </div>
              <div
                className={`w-16 h-16 rounded-2xl ${inv.avatarBg} flex items-center justify-center text-white font-display font-black text-xl shadow-lg`}
              >
                {inv.initials}
              </div>
              <h3 className="font-display mt-5 text-xl font-black text-slate-900">
                {inv.name}
              </h3>
              <p className="text-sm text-slate-500 mt-1">{inv.role}</p>

              <div className="mt-6 flex items-center justify-between border-t border-slate-100 pt-4">
                <div>
                  <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-400">
                    Return
                  </div>
                  <div className="font-display font-black text-slate-900 mt-0.5">
                    {inv.return}
                  </div>
                </div>
                <div className="text-right">
                  <div className="text-[10px] font-bold uppercase tracking-[0.15em] text-slate-400">
                    Style
                  </div>
                  <div className="font-display font-bold text-slate-900 mt-0.5 text-sm">
                    {inv.style}
                  </div>
                </div>
              </div>

              <div className="mt-5 flex items-center gap-2">
                <span className="rounded-full bg-[#D1FAE5] text-[#065F46] px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.1em]">
                  Mirroring
                </span>
                <span className="rounded-full bg-[#EDE9FE] text-[#5B21B6] px-2.5 py-0.5 text-[10px] font-bold uppercase tracking-[0.1em]">
                  Free
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MasterInvestors;
